var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadFileicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_1116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 15C15.7 15 15.5 14.9 15.3 14.7L12 11.4L8.7 14.7C8.3 15.1 7.7 15.1 7.3 14.7C6.9 14.3 6.9 13.7 7.3 13.3L11.3 9.3C11.7 8.9 12.3 8.9 12.7 9.3L16.7 13.3C17.1 13.7 17.1 14.3 16.7 14.7C16.5 14.9 16.3 15 16 15Z",
    fill: "#A3FF12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 20C11.4 20 11 19.6 11 19V10C11 9.4 11.4 9 12 9C12.6 9 13 9.4 13 10V19C13 19.6 12.6 20 12 20Z",
    fill: "#A3FF12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3987 17.4C19.9987 17.4 19.6987 17.2 19.4987 16.9C19.1987 16.4 19.3987 15.8 19.8987 15.5C20.7987 15 21.4987 14.1 21.7987 13.1C22.0987 12.1 21.9987 11 21.4987 10.1C20.7987 8.8 19.4987 8 17.9987 8H16.6987C16.1987 8 15.7987 7.7 15.6987 7.3C14.6987 3.6 10.8987 1.3 7.19874 2.3C5.39874 2.7 3.89874 3.8 2.99874 5.4C1.99874 7.1 1.79874 8.9 2.19874 10.8C2.49874 11.9 2.99874 12.9 3.69874 13.7C4.09874 14.1 3.99874 14.7 3.59874 15.1C3.19874 15.5 2.59874 15.4 2.19874 15C1.29874 13.9 0.598739 12.7 0.198739 11.3C-0.401261 9 -0.101261 6.6 1.19874 4.5C2.49874 2.4 4.39874 1 6.69874 0.400004C11.2987 -0.899996 15.9987 1.6 17.4987 6H17.9987C20.1987 6 22.1987 7.2 23.2987 9.1C24.0987 10.5 24.1987 12.1 23.7987 13.7C23.2987 15.2 22.2987 16.5 20.8987 17.3C20.6987 17.3 20.5987 17.4 20.3987 17.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 15C15.7 15 15.5 14.9 15.3 14.7L12 11.4L8.7 14.7C8.3 15.1 7.7 15.1 7.3 14.7C6.9 14.3 6.9 13.7 7.3 13.3L11.3 9.3C11.7 8.9 12.3 8.9 12.7 9.3L16.7 13.3C17.1 13.7 17.1 14.3 16.7 14.7C16.5 14.9 16.3 15 16 15Z",
    fill: "#A3FF12"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_1116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFileicon);
export default __webpack_public_path__ + "static/media/uploadFileicon.a250028562e984ef0a1d27c53891b510.svg";
export { ForwardRef as ReactComponent };